import { render } from "./FamilyRequestOptions.vue?vue&type=template&id=44754f3c"
import script from "./FamilyRequestOptions.vue?vue&type=script&lang=js"
export * from "./FamilyRequestOptions.vue?vue&type=script&lang=js"
script.render = render

export default script